module.exports = __webpack_public_path__ + "img/jquery.8ec9bacf.svg";